// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"be103382","107":"ea7d1fe3","677":"1fa85394"}[chunkId] + ".chunk.js";
};